import Api from "../common/Api";
import {Form, Input, message, Modal, Select, Spin} from "antd";
import React, {useState} from "react";

interface Refresh {
    [key: number]: number;
}

interface Props {
    username?: string;
    isVisible: {
        user: boolean,
        group: boolean
    }
    setVisible: React.Dispatch<React.SetStateAction<{
        user: boolean,
        group: boolean
    }>>;
    refresh: Refresh;
    setRefresh: React.Dispatch<React.SetStateAction<Refresh>>
}

interface SelectOptions {
    label: string;
    value: string;
}

const fetchData = async () => {
    const {data} = await Api.groupsManagement.getGroups();
    return data.map((group: any) => {
        return {
            label: group,
            value: group
        };
    });
}

const NewUserModal = (props: Props) => {
    const [form] = Form.useForm();
    const [manufacturers, setManufacturers] = useState<SelectOptions[]>();
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [dataFetch, setDataFetch] = useState(false);

    const getManufacturers = async () => {
        if (dataFetch)
            return;
        const manufacturersData = await fetchData();
        setManufacturers(manufacturersData);
        setLoading(false);
        setDataFetch(true);
    }

    return (
        <Modal
            title={"Create a new user"}
            visible={props.isVisible.user}
            okText={'Create user'}
            cancelText={'Cancel'}
            confirmLoading={buttonLoading}
            onOk={async () => {
                try {
                    setButtonLoading(true);
                    const values = await form.validateFields();
                    await Api.usersManagement.createUser({
                        email: values.email,
                        name: `${values.firstName} ${values.lastName}`,
                        manufacturer: values.manufacturer
                    });
                    props.setRefresh({...props.refresh, 1: props.refresh["1"] + 1})
                    form.resetFields();
                    props.setVisible({...props.isVisible, user: !props.isVisible.user})
                    message.success("Invitation sent!");
                } catch (e) {
                    message.error("Can't create user");
                } finally {
                    setButtonLoading(false);
                }
            }}
            onCancel={() => props.setVisible({...props.isVisible, user: !props.isVisible.user})}
        >
            <Form
                form={form}
                style={{height: "100%"}}
                name="basic"
                labelAlign={"left"}
                wrapperCol={{span: 24}}
                autoComplete="off"
            >
                <Form.Item className='form'>
                    <Form.Item
                        name="firstName"
                        className='first-name'
                        hasFeedback
                        rules={[{required: true, message: 'Please input your first name!'}]}
                    >
                        <Input placeholder="First Name *"/>
                    </Form.Item>
                    <Form.Item
                        className='last-name'
                        name="lastName"
                        hasFeedback
                        rules={[{required: true, message: 'Please input your last name!'}]}
                    >
                        <Input placeholder="Last Name *"/>
                    </Form.Item>
                </Form.Item>

                <Form.Item
                    name="email"
                    hasFeedback
                    rules={[{required: true, type: "email", message: 'Invalid email address!',}]}
                >
                    <Input placeholder="Email *"/>
                </Form.Item>

                <Form.Item name='manufacturer' rules={[{required: true, message: 'Select a manufacturer!',}]}>
                    <Select showSearch
                            loading={loading}
                            options={manufacturers!}
                            placeholder={"Group *"}
                            notFoundContent={manufacturers ? <Spin size="small"/> : null}
                            filterOption={(input, option) => (option!.label as unknown as string).includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA!.label as unknown as string)
                                    .toLowerCase()
                                    .localeCompare((optionB!.value as unknown as string).toLowerCase())
                            }
                            onClick={() => getManufacturers()}
                        />
                </Form.Item>
            </Form>
        </Modal>

    )
}

export default NewUserModal;
